export function DocumentBriefcase({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5 7.5V11.25C16.5 15 15 16.5 11.25 16.5H6.75C3 16.5 1.5 15 1.5 11.25V6.75C1.5 3 3 1.5 6.75 1.5H10.5L16.5 7.5Z"
          stroke="currentColor"
          strokeWidth="1.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.52319 6.89977V6.60441C7.52319 5.95093 7.52319 5.42297 8.70463 5.42297H9.29535C10.4768 5.42297 10.4768 5.95093 10.4768 6.60441V6.89977M9.73839 9.86076C9.73839 9.85707 9.73839 9.85707 9.73839 9.85338V9.48418C9.73839 9.11498 9.73839 9.11498 9.36919 9.11498H8.63079C8.26159 9.11498 8.26159 9.11498 8.26159 9.48418V9.86445M9.73839 9.86076C9.73839 10.2632 9.7347 10.5918 8.99999 10.5918C8.26898 10.5918 8.26159 10.2669 8.26159 9.86445M9.73839 9.86076C10.7352 9.73523 11.7099 9.36603 12.5628 8.74578M8.26159 9.86445C7.30536 9.75738 6.3676 9.41403 5.53689 8.84546M7.52319 12.807H10.4768C11.961 12.807 12.2268 12.2126 12.3043 11.4889L12.5812 8.53533C12.6809 7.63448 12.4225 6.89977 10.846 6.89977H7.15399C5.57751 6.89977 5.31907 7.63448 5.41875 8.53533L5.69565 11.4889C5.77318 12.2126 6.03901 12.807 7.52319 12.807Z"
          stroke="currentColor"
          strokeWidth="1.35"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
